<div class="asset-list-container nearby-asset-list-container _pendo-nearby">
    
    <div *ngIf="!findNearbyAssets else displayNearbyAssets" class="button-container">
        <button
            (click)="onButtonClick()"
            mat-stroked-button
            color="accent"
            class="find-nearby-assets-button _pendo-find-nearby-button"
        >{{ translateService.get(translations.appNearbyAssetsList.findNearbyAssets) | async | translate }}</button>
    </div>
    
    <ng-template #displayNearbyAssets>
        <app-progress-spinner  *ngIf="isLoading$ | async else loaded"></app-progress-spinner>
        <ng-template #loaded>
            <h3 class="asset-list-title">{{ translateService.get(translations.appNearbyAssetsList.nearbyAssets) | async | translate }}</h3>
            <div
                class="nearby-assets-list-wrapper"
                role="listbox"
                [attr.aria-label]="translateService.get(translations.appNearbyAssetsList.nearbyAssets) | async | translate"
                [attr.aria-activedescendant]="focusedAssetId ? 'nearby-asset-' + focusedAssetId : null"
                tabindex="0"
                (keydown)="onListKeydown($event)"
                (focus)="onListFocus()"
                (blur)="onListBlur()"
            >
                <app-asset-list-item *ngFor="let asset of nearbyAssets"
                    [id]="'nearby-asset-' + asset.assetId"
                    role="option"
                    [attr.aria-selected]="focusedAssetId === asset.assetId"
                    [class.focused-visible]="listHasFocus && focusedAssetId === asset.assetId"
                    [asset]="asset"
                    (hoverOver)="assetDetailsFacade.setHover(asset)"
                    (hoverOut)="assetDetailsFacade.clearHover()"
                    (itemClick)="setSelectedAsset(asset)"
                    class="_pendo-nearby-asset-item"
                ></app-asset-list-item>
            </div>
                <div *ngIf="nearbyAssets?.length === 0" class="no-nearby-assets-message-container mat-caption">
                    {{translateService.get(translations.appNearbyAssetsList.noAssetsPt1) | async | translate}} {{searchRadiusDistance}} {{ translateService.get(translations.appNearbyAssetsList.noAssetsPt2) | async | translate }}.
                </div>
        </ng-template>
    </ng-template>
</div>
